import { FC } from "react";
import styled from "styled-components/macro";
import { Route } from "react-router-dom";
import Footer from "./Footer";
import LandingNavbar from "./navbar";
import Home from "./home";
import AboutUs from "./aboutUs";
// import Careers from './career';
import ContactUs from "./contactUs";
import Theme from "../constants/Theme";
import media from "../constants/MediaQuery";

interface LandingPage {}

interface RouteT {
  path: string;
  component: any;
  exact: boolean;
  icon?: any;
  label?: string;
  navBarExclude: boolean;
  private: boolean;
}

export const LandingRoutes: RouteT[] = [
  {
    path: "/",
    component: Home,
    exact: true,
    navBarExclude: true,
    private: false,
  },
  {
    path: "/about-us",
    component: AboutUs,
    exact: true,
    navBarExclude: true,
    private: false,
  },
  {
    path: "/career",
    component: Home,
    exact: true,
    navBarExclude: true,
    private: false,
  },
  {
    path: "/contact-us",
    component: ContactUs,
    exact: true,
    navBarExclude: true,
    private: false,
  },
];

export type navLinksType = Array<{ label: string; link: string }>;

export const navLinks: navLinksType = [
  { label: "about Us", link: "/about-us" },
  { label: "Career", link: "/career" },
  { label: "contact us", link: "/contact-us" },
  // { label: "Login", link: "https://app.dotpay.africa/" },
];

const Landing: FC<LandingPage> = () => {
  return (
    <LandingPageStyling>
      <LandingNavbar navLinks={navLinks} />
      {LandingRoutes.map((routes) => (
        <Route key={routes.path} {...routes} />
      ))}
      <Footer />
    </LandingPageStyling>
  );
};
const LandingPageStyling = styled.div`
  width: 100%;
  .container {
    max-width: 1180px;
  }

  .landing {
    &__heading {
      font-size: calc(${Theme.fontSizes.extralarge} - 30%);
      margin-bottom: 14px;
    }
    &-btn {
      margin-top: 30px;
    }
    &--text-summary {
      font-size: calc(${Theme.fontSizes.xxlarge} - 30%);
      margin: 0 0 10px 0;
    }
    &--content-text {
      font-size: calc(${Theme.fontSizes.xlarge} - 30%);
    }
    @media screen and (min-width: 768px) {
      &__heading {
        font-size: ${Theme.fontSizes.extralarge};
      }
      &--text-summary {
        font-size: ${Theme.fontSizes.xxlarge};
      }
      &--content-text {
        font-size: ${Theme.fontSizes.xlarge};
      }
    }
  }

  .logo {
    height: 40px;
    margin: 0 0 25px 0;
    ${media.tabletMin`
       height:50px;
    `}
  }

  .footer-title-links {
    margin: 18px 0;
    padding: 0 4px;
    white-space: nowrap;
    text-transform: uppercase;
    cursor: pointer;
  }
  .titles-subheadings {
    font-size: ${Theme.fontSizes.large};
    margin: 5px 0;
    @media screen and (min-width: 1024px) {
      font-size: ${Theme.fontSizes.xxlarge};
    }
  }
  .text-heading {
    font-size: ${Theme.fontSizes.xextralarge};
    white-space: nowrap;
  }
  .landing-btn {
    font-weight: ${Theme.fontWeights.semiBold};
    font-size: ${Theme.fontSizes.large};
    max-width: 318px;
    width: 100%;
    height: 72px;
    display: flex;
    justify-content: space-between;
    @media screen and (max-width: 1248px) {
      margin: 20px 0;
    }
  }
  .icon-free-btn {
    font-weight: ${Theme.fontWeights.medium};
    font-size: ${Theme.fontSizes.xxlarge};
    letter-spacing: 0.115em;
    text-transform: uppercase;
    margin-top: 30px;
    border: 2px solid;
    padding: 16px;
    max-width: 279px;
  }
  .titles-subheadings {
    font-size: ${Theme.fontSizes.large};
    margin: 5px 0;
    @media screen and (min-width: 1024px) {
      font-size: ${Theme.fontSizes.xxlarge};
    }
  }
  .text-heading {
    font-size: ${Theme.fontSizes.xextralarge};
    white-space: nowrap;
  }
  .landing-btn {
    font-weight: ${Theme.fontWeights.semiBold};
    font-size: ${Theme.fontSizes.large};
    max-width: 318px;
    width: 100%;
    height: 72px;
    display: flex;
    justify-content: space-between;
    @media screen and (max-width: 1248px) {
      margin: 20px 0;
    }
  }
  .icon-free-btn {
    font-weight: ${Theme.fontWeights.medium};
    font-size: ${Theme.fontSizes.xxlarge};
    letter-spacing: 0.115em;
    text-transform: uppercase;
    margin-top: 30px;
    border: 2px solid;
    padding: 16px;
    max-width: 279px;
  }
`;
export default Landing;
